import React from "react";
import { Faqs, getProcessedFaqs } from "@components/shared";
import * as c from "./lpFaqSection.module.scss";

const LpFaqSection = ({ items, ...props }) => {
  const processedFaqs = getProcessedFaqs(items);
  return (
    <section className={c.container}>
      <Faqs faqs={processedFaqs} {...props} noAnchorLinks />
    </section>
  );
};

export { LpFaqSection };
